import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Tabs,
  Tab,
  Grid,
  Card,
  CardMedia,
  CircularProgress,
  CardContent,
  useMediaQuery,
} from "@mui/material";
import { updateAvailability, storage, db } from "../../firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import useAllPropertiesData from "../../utils/hooks/usePropertyData";
import updatePropertyData from "../../utils/hooks/updatePropertyData";
import { doc, getDoc } from "firebase/firestore";
import { deleteProperty } from "../../firebaseConfig";
import Navbar from "../../components/Navbar/Navbar";
import FileUpload from "../../utils/hooks/useFileUpload";

const useFirebaseStorageUpload = (folder, titolo) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [urls, setUrls] = useState([]);
  const uploadFiles = async (files) => {
    setUploading(true);
    try {
      const promises = files.map(async (file) => {
        const fileRef = ref(storage, `${folder}/${titolo}/${file.name}`);
        await uploadBytes(fileRef, file);
        const url = await getDownloadURL(fileRef);
        return url;
      });

      const uploadedUrls = await Promise.all(promises);
      setUrls(uploadedUrls);
    } catch (error) {
      setError(error);
    } finally {
      setUploading(false);
    }
  };

  return { uploading, error, urls, uploadFiles };
};

function AdminPage() {
  const [formData, setFormData] = useState({
    titolo: "",
    indirizzo: "",
    prezzo: "",
    grandezza: "",
    camere: "",
    bagni: "",
    piano: "",
    dettagli: "",
    contratto: "",
    descrizione: "",
    pianiEdificio: "",
    ascensore: "",
    superficie: "",
    locali: "",
    cucina: "",
    arredato: "",
    balcone: "",
    terrazzo: "",
    riscaldamento: "",
    climatizzazione: "",
    speseCondominio: "",
    classeEnergetica: "",
    condizioni: "",
    images: [], // Aggiungi un campo per le immagini
    planimetria: null,
    video: null,
  });

  const { propertiesData, loading } = useAllPropertiesData();
  const handleDelete = async (titolo) => {
    if (
      window.confirm(
        `Sei sicuro di voler eliminare l'immobile con titolo: ${titolo}?`
      )
    ) {
      try {
        await deleteProperty(titolo);
        alert("Immobile eliminato con successo!");
        window.location.reload();
      } catch (error) {
        console.error("Errore durante l'eliminazione:", error);
        alert("Errore durante l'eliminazione dell'immobile.");
      }
    }
  };
  // -----------------

  const { uploading, error, urls, uploadFiles } = useFirebaseStorageUpload(
    "properties",
    formData.titolo
  );
  const {
    uploading: planimetriaUploading,
    error: planimetriaError,
    urls: planimetriaUrls,
    uploadFiles: uploadPlanimetria,
  } = useFirebaseStorageUpload("planimetria", formData.titolo);
  const {
    uploading: videoUploading,
    error: videoError,
    urls: videoUrls,
    uploadFiles: uploadVideo,
  } = useFirebaseStorageUpload("video", formData.titolo);
  // -----------------
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [isEdit, setIsEdit] = useState(false);
  const handleEdit = (property) => {
    setIsEdit(true);
    // Pre-compila i dati nel form
    setFormData({
      titolo: property.titolo,
      indirizzo: property.indirizzo,
      prezzo: property.prezzo,
      grandezza: property.grandezza,
      camere: property.camere,
      bagni: property.bagni,
      piano: property.piano,
      dettagli: property.dettagli,
      contratto: property.contratto,
      descrizione: property.descrizione,
      pianiEdificio: property.pianiEdificio,
      ascensore: property.ascensore,
      superficie: property.superficie,
      locali: property.locali,
      cucina: property.cucina,
      arredato: property.arredato,
      balcone: property.balcone,
      terrazzo: property.terrazzo,
      riscaldamento: property.riscaldamento,
      climatizzazione: property.climatizzazione,
      speseCondominio: property.speseCondominio,
      classeEnergetica: property.classeEnergetica,
      condizioni: property.condizioni,
      images: property.photos || [],
      planimetria: property.planimetria,
      video: property.video,
    });
    setTabIndex(0); // Vai alla tab di inserimento per modificare
  };
  const isMobile = useMediaQuery("(max-width: 768px)");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Trim del titolo nel caso qualcosa non fosse trimmato correttamente
    const trimmedTitolo = formData.titolo.trim();

    // Aggiorna il formData con il titolo trimmato
    setFormData((prevData) => ({
      ...prevData,
      titolo: trimmedTitolo,
    }));

    try {
      await uploadFiles(formData.images);

      if (formData.planimetria) {
        await uploadPlanimetria([formData.planimetria]);
      }
      if (formData.video) {
        await uploadVideo([formData.video]);
      }

      const propertyDocRef = doc(db, "immobili", trimmedTitolo); // Usa il titolo trimmato
      const propertyDoc = await getDoc(propertyDocRef);
      if (propertyDoc.exists()) {
        console.log("Immobile esistente trovato. Aggiornamento in corso...");
        // Aggiorna i dati dell'immobile
        await updatePropertyData(trimmedTitolo, formData);
        alert("Proprietà aggiornata con successo!");
      } else {
        // Se il titolo non esiste, aggiorna la disponibilità (crea una nuova proprietà)
        console.log(
          "Immobile non trovato. Creazione di una nuova proprietà..."
        );
        await updateAvailability(
          trimmedTitolo,
          formData.indirizzo,
          formData.prezzo,
          formData.grandezza,
          formData.camere,
          formData.bagni,
          formData.piano,
          formData.dettagli,
          formData.contratto,
          formData.descrizione,
          formData.pianiEdificio,
          formData.ascensore,
          formData.superficie,
          formData.locali,
          formData.cucina,
          formData.arredato,
          formData.balcone,
          formData.terrazzo,
          formData.riscaldamento,
          formData.climatizzazione,
          formData.speseCondominio,
          formData.classeEnergetica,
          formData.condizioni
        );
        alert("Nuova proprietà aggiunta con successo!");
        window.location.reload();
      }
    } catch (error) {
      console.error("Errore durante l'aggiornamento della proprietà:", error);
    }
  };
return (
  <Box
    sx={{
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 3,
      color: "#fff",
    }}
  >
    {isMobile ? "" : <Navbar />}
    <Typography
      variant="h4"
      sx={{ marginTop: "100px", marginBottom: 2, color: "#0C6D8D" }}
    >
      Pannello di Amministrazione
    </Typography>
    <Tabs value={tabIndex} onChange={handleTabChange} sx={{ marginBottom: 3 }}>
      <Tab label="Gestione Immobili" />
      <Tab label="Immobili" />
    </Tabs>
    {tabIndex === 0 && (
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: isMobile ? "100%" : "50%",
        }}
      >
        {Object.keys(formData).map((field) => {
          if (field === "descrizione") {
            return (
              <TextField
                key={field}
                label="Descrizione"
                name={field}
                value={formData[field]}
                onChange={handleChange}
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                sx={{ backgroundColor: "#fff", borderRadius: 1 }}
              />
            );
          } else if (field === "images") {
            return (
              <FileUpload
                isEdit={isEdit}
                key={field}
                folder="properties"
                title={formData.titolo}
                field={field}
                label="Carica le foto della proprietà"
                accept="image/*"
                multiple={true}
                onChange={(urls) =>
                  setFormData((prevData) => ({ ...prevData, images: urls }))
                }
              />
            );
          } else if (field === "planimetria") {
            return (
              <>
                <FileUpload
                  isEdit={isEdit}
                  key={field}
                  folder="planimetria"
                  metria
                  title={formData.titolo}
                  field={field}
                  label="Carica le foto della planimetria"
                  accept="image/*"
                  multiple={true}
                  onChange={(urls) =>
                    setFormData((prevData) => ({ ...prevData, images: urls }))
                  }
                />
              </>
            );
          } else if (field === "video") {
            return (
              <FileUpload
                isEdit={isEdit}
                key={field}
                folder="video"
                metria
                title={formData.titolo}
                field={field}
                label="Carica il video"
                accept="video/*"
                multiple={true}
                onChange={(urls) =>
                  setFormData((prevData) => ({ ...prevData, images: urls }))
                }
              />
            );
          } else {
            return (
              <TextField
                key={field}
                label={field.charAt(0).toUpperCase() + field.slice(1)}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                sx={{ backgroundColor: "#fff", borderRadius: 1 }}
              />
            );
          }
        })}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={uploading}
        >
          {uploading ? "Caricamento..." : "Salva"}
        </Button>
        {error && <p style={{ color: "red" }}>{error.message}</p>}
      </Box>
    )}
    {/* Sezione Immobili */}
    {tabIndex === 1 && (
      <>
        {" "}
        <Box sx={{ width: "60%", textAlign: "center" }}>
          <Typography variant="h5">Sezione Immobili</Typography>
          {loading ? (
            <CircularProgress />
          ) : (
            <Grid container spacing={2} justifyContent="center">
              {propertiesData.length === 0 ? (
                <Typography variant="h6">
                  Nessun immobile disponibile
                </Typography>
              ) : (
                propertiesData.map((property, index) => (
                  <Grid item key={index} xs={12} sm={6} md={4}>
                    <Card sx={{ maxWidth: 445 }}>
                      {property.photos && property.photos.length > 0 ? (
                        <CardMedia
                          component="img"
                          height="140"
                          image={property.photos[0]}
                          alt={property.titolo}
                        />
                      ) : (
                        <CardMedia
                          component="img"
                          height="140"
                          image="https://via.placeholder.com/345x140.png?text=No+Image"
                          alt="No Image"
                        />
                      )}
                      <CardContent>
                        <Typography
                          sx={{
                            minHeight: "100px",
                          }}
                          variant="h6"
                        >
                          {property.titolo}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {property.indirizzo}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Prezzo: €{property.prezzo}
                        </Typography>

                        {/* Pulsante Modifica */}
                        <Button
                          onClick={() => handleEdit(property)}
                          variant="contained"
                          color="primary"
                          sx={{ marginTop: 2, marginRight: 1 }}
                        >
                          Modifica
                        </Button>

                        {/* Pulsante Elimina */}
                        <Button
                          onClick={() => handleDelete(property.titolo)}
                          variant="contained"
                          color="secondary"
                          sx={{ marginTop: 2 }}
                        >
                          Elimina
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              )}
            </Grid>
          )}
        </Box>
      </>
    )}
  </Box>
);
}

export default AdminPage;
